export default {"src":"/_next/static/media/pepsi.0d8c1371.svg","height":121,"width":170,"blurWidth":0,"blurHeight":0};